<template>
    <div class="products__grid" uk-grid>
        <div v-for="item in items" class="uk-width-1-3@m uk-width-1-3@l" data-uk-rr-eec-view="{'event':'productImpression','ecommerce': {'impressions' : {'name': 'Triblend Android T-Shirt','id': '12345','price': '15.25','brand': 'Google','category': 'Apparel','variant': 'Gray','list': 'Search Results','position': 1}">
            <!-- TODO:implement generic rr-eec-view -->
            <div class="product-card uk-card uk-card-small uk-flex uk-flex-wrap uk-flex-middle">

                <div class="product-card__media-wrapper uk-card-media-top uk-width-1-1 uk-width-1-3@s uk-width-1-1@m" v-if="item.featured_media">
                    <figure class="product-card__media uk-position-relative uk-margin-remove">
                        <span v-html="item.featured_media.data.thumbnail"></span>
                        <a :href="item.url" class="uk-position-cover"></a>
                        <div class="uk-position-top-right uk-badge" v-if="item.price_reduced">Promo</div>
                    </figure>
                </div>

                <div class="product-card__body uk-card-body uk-width-1-1 uk-width-2-3@s uk-width-1-1@m">
                    <h3 class="product-card__title uk-margin-remove">
                        <a :href="item.url" v-html="item.name"></a>
                    </h3>
                    <p class="product-card__text uk-margin-remove uk-text-small" v-html="item.abstract"></p>
                    <p class="product-card__info uk-margin-remove-top uk-margin-bottom uk-visible@m uk-text-meta">
                        Cod.
                        {{ item.code }}
                    </p>
                    <div class="product-card__price product-card__price_discounted uk-text-muted uk-hidden-small" v-if="item.price_reduced">
                        <del class="product-card__price-discounted">{{item.original_price}}</del>
                        <span class="product-card__discount-badge uk-badge">- {{ item.percentage }}%</span>
                    </div>
                    <div class="product-card__price">
                        <span class="uk-text-bold">{{ item.price }}</span>
                    </div>

                    <div class="product-card__button-wrapper uk-flex uk-margin-top">
                        <!--TODO: add wishlist button? -->
                        <div class="uk-width-1-2">
                            <a :href="item.url" class="product-card__button uk-button uk-button-primary uk-width-1-1">
                                <i class="far fa-cart-plus"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import DataGridResults from 'js/theme-mixins/DataGridResults';

  export default {
    mixins: [DataGridResults],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/taxonomies/assets/js/components/ProductCategoriesDataGridResults.vue